import { reactive } from "vue";

export const langStore = reactive({
  lang: "en",
});
